// extracted by mini-css-extract-plugin
export default {"root":"_1btLG","llama":"_31KZ4","big":"_3eipJ","small":"WOKdm"};